import React, { FC } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { TextInput, PhoneInput, useFormContext } from 'framework/form';
import { EDITABLE_LIST_FIELD, EDITABLE_LIST_GROUP } from 'framework/list';
import { compactDisabledInputSx } from 'domain/projects/newProject/shared/compactDisabledInputSx';
import PredecessorSection from './PredecessorSection';

const getTableCells = async (isEditMode: boolean) => {
  const disabled = !isEditMode;
  return [
    {
      type: EDITABLE_LIST_FIELD,
      source: 'alias',
      isEditor: true,
      component: TextInput,
      componentProps: { label: '', disabled: true },
      gridCellProps: { size: 0.5, sx: compactDisabledInputSx },
    },
    {
      type: EDITABLE_LIST_GROUP,
      component: Grid,
      componentProps: { container: true, alignItems: 'start', spacing: 1 },
      gridCellProps: {
        size: 11,
        sx: {
          '.floating-label-input': { mb: '0px!important' },
          '.floating-label-baseInput': { mb: '0px!important' },
          '.MuiFormControl-root': { mb: '0px!important' },
        },
      },
      children: [
        {
          type: EDITABLE_LIST_FIELD,
          source: 'name',
          isEditor: true,
          component: TextInput,
          componentProps: { label: 'Name', disabled },
          gridCellProps: { size: 3 },
        },
        {
          type: EDITABLE_LIST_FIELD,
          source: 'jobTitle',
          isEditor: true,
          component: TextInput,
          componentProps: { label: 'Job Title', disabled },
          gridCellProps: { size: 3 },
        },
        {
          type: EDITABLE_LIST_FIELD,
          source: 'email',
          isEditor: true,
          component: TextInput,
          componentProps: { label: 'Email', disabled },
          gridCellProps: { size: 3 },
        },
        {
          type: EDITABLE_LIST_FIELD,
          source: 'phone',
          isEditor: true,
          component: PhoneInput,
          componentProps: { label: 'Phone', disabled },
          gridCellProps: { size: 3 },
        },
      ],
    },
  ];
};

const PredecessorStakeholders: FC = () => {
  const { data } = useFormContext();
  const stakeholders = data?.stakeholders ?? [];

  return (
    <PredecessorSection
      title="Stakeholders"
      listSource="stakeholders"
      isEmpty={stakeholders.length === 0}
      getTableCells={getTableCells}
    />
  );
};

export default PredecessorStakeholders;
